import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import NavbarGenerale from "./Navbar";
import Input from "../../components/Input";
import Alert from "../../components/Alert";
import Button from "../../components/Button";
import { SquarePen } from "lucide-react";

const Attiva = () => {
    const [codiceDominio, setCodiceDominio] = useState("");
    const [ragioneSociale, setRagioneSociale] = useState("");
    const [indirizzo, setIndirizzo] = useState("");
    const [cap, setCap] = useState("");
    const [citta, setCitta] = useState("");
    const [provincia, setProvincia] = useState("");
    const [nomeManager, setNomeManager] = useState("");
    const [cognomeManager, setCognomeManager] = useState("");
    const [emailManager, setEmailManager] = useState("");
    const [passwordManager, setPasswordManager] = useState("");
    const [codiceAtt, setCodiceAtt] = useState("");
    const [infoCodiceAtt, setInfoCodiceAtt] = useState({});
    const [isResocontoVisible, setIsResocontoVisible] = useState(false);
    const [durataTrial, setDurataTrial] = useState(0);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        if (localStorage.getItem('infoDominio') && localStorage.getItem("successVerify") === "true") {
            const infoDominio = JSON.parse(localStorage.getItem('infoDominio'));
            setCodiceDominio(infoDominio.codice);
            setRagioneSociale(infoDominio.ragione);
            setIndirizzo(infoDominio.indirizzo);
            setCap(infoDominio.cap);
            setCitta(infoDominio.citta);
            setProvincia(infoDominio.provincia);
            setNomeManager(infoDominio.nomeManager);
            setCognomeManager(infoDominio.cognomeManager);
            setEmailManager(infoDominio.emailManager);
            setPasswordManager(infoDominio.passwordManager);
            onload();
        } else {
            setAlertInfo({ type: "warning", text: "Nessuna informazione di dominio trovata. Assicurati di aver creato un dominio prima di attivarlo.", onClose: () => navigate('/crea'), needConfirm: false });
            setShowAlert(true);
        }
    }, []);

    const onload = async () => {
        try {
            const r = await fetch('/getParametri', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            const rd = await r.json();

            if (r.status === 500) {
                console.log(rd["error"]);
                setAlertInfo({ type: "error", text: rd["error"], onClose: () => navigate('/crea'), needConfirm: false });
                setShowAlert(true);
            }
            else {
                setDurataTrial(rd[0].DurataTrialMesi);
            }
        } catch (error) {
            console.error("Error fetching parameters:", error);
            setAlertInfo({ type: "error", text: "Si è verificato un errore durante il caricamento dei parametri.", onClose: () => navigate('/crea'), needConfirm: false });
            setShowAlert(true);
        }
    };

    const conferma = async (IsTrial) => {
        try {
            const r = await fetch('/setupDominio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Nome: nomeManager,
                    Cognome: cognomeManager,
                    Email: emailManager,
                    Password: passwordManager,
                    Livello: "Manager",
                    CodiceDominio: codiceDominio,
                    Stato: "Attivo",
                    IDLicenza: IsTrial ? "" : infoCodiceAtt.ID,
                    Indirizzo: indirizzo,
                    CAP: cap,
                    Citta: citta,
                    Provincia: provincia,
                    RagioneSociale: ragioneSociale,
                    PreavvisoManutenzione: 30,
                    InvioMailRiepilogo: true,
                    GiorniMailRiepilogo: 7,
                    IsTrial: IsTrial
                })
            });

            if (r.status !== 200) {
                const rd = await r.json();
                localStorage.removeItem('infoDominio');
                localStorage.removeItem("successVerify");
                setAlertInfo({ type: "error", text: rd["error"], onClose: () => navigate('/crea'), needConfirm: false });
                setShowAlert(true);
            };

            localStorage.removeItem('infoDominio');
            localStorage.removeItem("successVerify");
            navigate('/');
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nella connessione al server, riprova più tardi", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
    };

    const checkCodice = async () => {
        if (codiceAtt === "") return;

        try {
            const r = await fetch('/checkCodiceAttivazione', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodiceAtt: codiceAtt }),
            });

            const rd = await r.json();

            if (r.status === 200) {
                if (rd[0].Obsoleto) {
                    setAlertInfo({ type: "error", text: "Codice obsoleto, inserire un altro codice", onClose: () => setShowAlert(false), needConfirm: false });
                    setCodiceAtt("");
                    return;
                };

                if (rd[0].DataAttivazione !== null) {
                    setAlertInfo({ type: "error", text: "Codice già utilizzato, inserire un altro codice", onClose: () => setShowAlert(false), needConfirm: false });
                    setCodiceAtt("");
                    return;
                };

                setInfoCodiceAtt(rd[0]);
                setIsResocontoVisible(true);
            }
            else {
                setAlertInfo({ type: "error", text: rd["error"], onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setCodiceAtt("");
            }
        } catch (error) {
            setAlertInfo({ type: "error", text: "Errore nella connessione al server, riprova più tardi", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            console.log(error);
        }

    };

    return (
        <div className="h-[100svh]">
            <NavbarGenerale />
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto flex flex-col justify-center items-center">
                <p>ATTIVA IL TUO DOMINIO</p>
                <p>
                    oppure
                    <span className="text-blue-600 underline font-semibold hover:cursor-pointer ml-1" onClick={() => { localStorage.removeItem('infoDominio'); localStorage.removeItem("successVerify"); navigate('/') }}>esegui la login</span>
                </p>
                <p className="mt-8">Revisione del dominio</p>
                <div className="w-[80%] md:w-[50%] mt-3">
                    <p className="flex justify-between">
                        Codice/P.iva :
                        <span className="font-semibold">{codiceDominio}</span>
                    </p>
                    <p className="flex justify-between mt-1">
                        Ragione Sociale :
                        <span className="font-semibold">{ragioneSociale}</span>
                    </p>
                    <p className="flex justify-between mt-1">
                        Indirizzo :
                        <span className="font-semibold">{indirizzo}</span>
                    </p>
                    <p className="flex justify-between mt-1">
                        CAP :
                        <span className="font-semibold">{cap}</span>
                    </p>
                    <p className="flex justify-between mt-1">
                        Città :
                        <span className="font-semibold">{citta}</span>
                    </p>
                    <p className="flex justify-between mt-1">
                        Provincia :
                        <span className="font-semibold">{provincia}</span>
                    </p>
                </div>
                <Button type="hollow" classes="w-[80%] md:w-[50%] mt-2" onClick={() => { localStorage.removeItem("successVerify"); navigate('/crea') }}>
                    MODIFICA <SquarePen size={20} className="inline ml-1" />
                </Button>
                <p className="mt-8">Attiva la licenza</p>
                <Input
                    label="Codice di attivazione"
                    value={codiceAtt}
                    setValue={setCodiceAtt}
                    type="text"
                    classes="w-[80%] md:w-[50%] mt-1"
                    disabled={false}
                    error={false}
                    blurAction={checkCodice}
                />
                {
                    !isResocontoVisible ? (
                        <>
                            <div className="relative flex items-center justify-center w-[80%] md:w-[50%] my-4">
                                <div className="absolute w-full h-1 bg-gray-200 dark:bg-neutral-800 rounded"></div>
                                <span className="relative px-3 bg-gray-100 dark:bg-neutral-900 ">oppure</span>
                            </div>
                            <Button type="full" classes="w-[80%] md:w-[50%]" onClick={() => conferma(true)}>
                                TRIAL DI {durataTrial} MESE
                            </Button>
                        </>
                    ) : (
                        <>
                            <p className="mt-8">Revisione del piano</p>
                            <div className="w-[80%] md:w-[50%] mt-1">
                                <p className="flex justify-between">
                                    Nome :
                                    <span className="font-semibold">{infoCodiceAtt.Nome}</span>
                                </p>
                                <p className="flex justify-between mt-1">
                                    Descrizione :
                                    <span className="font-semibold">{infoCodiceAtt.Descrizione}</span>
                                </p>
                            </div>
                            <div className="grid grid-cols-2 mt-2 gap-2 w-[80%] md:w-[50%]">
                                <Button type="hollow" onClick={() => { setInfoCodiceAtt({}); setCodiceAtt(""); setIsResocontoVisible(false); }}>
                                    ANNULLA
                                </Button>
                                <Button type="full" onClick={() => conferma(false)}>
                                    CONFERMA
                                </Button>
                            </div>
                        </>
                    )
                }
            </div>
        </div>
    )
};
export default Attiva;